import { useTranslation } from 'react-i18next';

import { ConfirmActionModal } from '@/components/common';

interface CancelContractModalProps {
  opened: boolean;
  contractLabel: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  isPaused?: boolean;
}

export const CancelContractModal = ({
  opened,
  contractLabel,
  onClose,
  onConfirm,
  loading,
  isPaused
}: CancelContractModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionModal
      opened={opened}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      isPaused={isPaused}
      danger
      title={t('contractDetail.cancelModalTitle')}
      message={t('contractDetail.cancelModalMessage', { number: contractLabel })}
      confirmLabel={t('contractDetail.cancelModalConfirm')}
    />
  );
};
